import {
    DTOCardFormField,
    NestedField,
} from 'app/types/form.types'
import {
    ContactType,
    DecisionMakingUnit,
    AttitudeToSkyCell,
    Department,
    LeadSource,
} from 'app/enums/label.enums'
import {
    WithId,
} from 'app/types/common.types'

import {
    EngagementType,
} from '../engagement.types'

type Fields = EngagementType & {
    company: WithId<number>,
    contactCountry: WithId<number>
}

const getFields = (
    {
        getAllowedValues,
        exists,
        disabled,
        company,
        country,
        l,
    }:
    {
        getAllowedValues: (enumType: Record<string, string>) => Record<string, string>,
        exists: boolean,
        disabled: boolean,
        company?: WithId<number>
        country?: WithId<number>
        l: (key: string) => string,
    },
): DTOCardFormField<keyof Fields>[] => {
    return [{
        title: exists ? l('ENGAGEMENT_DETAILS') : l('NEW_ENGAGEMENT'),
        fields: [
            {
                id: 'column1',
                fields: [
                    {
                        name: 'contact',
                        componentName: 'ContactObjectSelector',
                        includeFilters: {
                            type: [ContactType.SKYCELL_COMMERCIAL],
                        },
                        required: true,
                        disabled: exists,
                        labelKey: 'NAME_AND_SURNAME',
                        showOptionLabelWithEmail: true,
                    },
                    ...disabled ? [{
                        name: 'attitudeToSkyCell',
                        componentName: 'AttitudeToSkyCell',
                        labelKey: 'ATTITUDE_TO_SKYCELL',
                        disabled,
                    }] as NestedField<keyof Fields>[] : [{
                        name: 'attitudeToSkyCell',
                        componentName: 'EnumSelector',
                        allowedValues: getAllowedValues(AttitudeToSkyCell),
                        useDropdown: true,
                        required: true,
                        labelKey: 'ATTITUDE_TO_SKYCELL',
                    }] as NestedField<keyof Fields>[],
                    {
                        name: 'leadSource',
                        componentName: 'EnumSelector',
                        allowedValues: getAllowedValues(LeadSource),
                        useDropdown: true,
                        labelKey: 'LEAD_SOURCE',
                    },
                ],
            },
            {
                id: 'column2',
                fields: [
                    {
                        name: 'company',
                        componentName: 'CompanyObjectSelector',
                        value: company,
                        disabled: true,
                        labelKey: 'COMPANY',
                    },
                    {
                        name: 'contactCountry',
                        componentName: 'CountryDataSelector',
                        value: country,
                        disabled: true,
                        labelKey: 'BASED_IN_COUNTRY',
                    },
                    ...disabled ? [] : [{
                        name: 'department',
                        componentName: 'EnumSelector',
                        allowedValues: getAllowedValues(Department),
                        useDropdown: true,
                        labelKey: 'DEPARTMENT',
                    }] as NestedField<keyof Fields>[],
                    {
                        name: 'reportingTo',
                        componentName: 'ContactObjectSelector',
                        includeFilters: {
                            companyId: company?.id ? [company?.id] : undefined,
                        },
                        labelKey: 'REPORTING_TO',
                        showOptionLabelWithEmail: true,
                    },
                    {
                        name: 'decisionMakingUnit',
                        componentName: 'EnumSelector',
                        useDropdown: true,
                        allowedValues: getAllowedValues(DecisionMakingUnit),
                        labelKey: 'DECISION-MAKING_UNIT',
                    },
                ],
            },
            {
                id: 'column3',
                fields: [
                    {
                        name: 'newsletterUnsubscribed',
                        componentName: 'Checkbox',
                        labelKey: 'NEWSLETTER_UNSUBSCRIBED',
                    },
                    {
                        name: 'gdprConsent',
                        componentName: 'Checkbox',
                        labelKey: 'CONSENT_OBTAINED',
                    },
                    {
                        name: 'interestInSkyMind',
                        componentName: 'Checkbox',
                        labelKey: 'EXPRESSED_INTEREST_IN_SKYMIND',
                    },
                    {
                        name: 'interestIn1500X',
                        componentName: 'Checkbox',
                        labelKey: 'EXPRESSED_INTEREST_IN_1500X',
                    },
                ],
            },
        ],
    }]
}

export default getFields
